// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconDelete } from 'components/atoms/icons/IconDelete';
import styles from './index.module.scss';
import { IconDraggable } from 'components/atoms/icons/IconDraggable';
import { EmissionSite } from 'types/routeManagementTypes';
import Popover from 'components/atoms/Popover';

interface SiteItemProps {
  site: EmissionSite;
  index: number;
  onRemove: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dragHandleProps: any;
}

const SiteItem = ({
  site,
  index,
  onRemove,
  dragHandleProps,
}: SiteItemProps) => {
  return (
    <div className={styles.point}>
      <div {...dragHandleProps} className={styles.dragHandle}>
        <IconDraggable size={32} />
      </div>
      <div className={styles.info}>
        <span className={styles.order}>{index + 1}</span>
        <div className={styles.textContainer}>
          <Popover
            content={site.name}
            autoGen={{
              lines: 1,
              odd: 4,
            }}
            positions={['top']}
            containerStyle={{
              maxWidth: '750px',
              wordBreak: 'break-all',
            }}
          >
            <div className={styles.siteName}>{site.name}</div>
          </Popover>
          <div className={styles.address}>{site.address}</div>
        </div>
      </div>
      <span className="pointer">
        <IconDelete stroke="#e7e7e7" onClick={onRemove} />
      </span>
    </div>
  );
};
export default SiteItem;
